import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInboxChecked: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconInboxChecked"><Path d="M7 10.5497L10.85 14.5L18 4" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 14.5V20.5H20.5V14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconInboxChecked;
